"use strict";

const countryMap = {at: "A", be: "B", de: "D", es: "E", fr: "F", it: "I", lu: "L", nl: "NL"};

let cachedDocumentCountry;

let get = () => {
    if (cachedDocumentCountry === undefined) {
        var jsData = document.getElementById("js-data");
        if (jsData) {
            cachedDocumentCountry = jsData.getAttribute("data-country").toLowerCase();
        }
    }
    return cachedDocumentCountry;
};

let isOneOf = (countryArray) => {
    return countryArray.indexOf(get()) !== -1;
};

let asDropDownValue = () => {
    return countryMap[get()];
};

module.exports = {
    get,
    isOneOf,
    asDropDownValue
};
